import { gql, useMutation } from '@apollo/client'

const mutation = gql`
  mutation createEvent($groupId: String!, $name: String!, $description: String, $startDate: String!, $endDate: String, $image: String, $location: String, ) {
    createEvent(groupId: $groupId, name: $name description: $description, endDate: $endDate, image: $image, location: $location, startDate: $startDate) {
      post {
        id
      }
    }
  }
`

export interface CreateEventInput {
  groupId: string
  name: string
  description?: string
  startDate: string
  endDate?: string
  image?: string
  location?: string
}

export interface CreateEventOutput {
  createEvent: {
    post: {
      id: string
    }
  }
}

export const useCreateEvent = () => useMutation<CreateEventOutput, CreateEventInput>(mutation)
